import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";
import usePavanData from "./hooks/usePavanData";

// // Import the May2023.json file
// import May2023 from "./components/Body/May2023.json";
const Footer = lazy(() =>
  import("./components//CommenFooterComponent/index.js")
);
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() =>
  import("./components/Morganlogos/Morganlogos.js")
);
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();
  const [links, setLinks] = useState(null); // Set initial state as null
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("")
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
  const pavanData = usePavanData();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink,"Sun West Mortgage Company, Inc.")
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  const appVersion = appversion.version;

  useEffect(() => {
    //Comment out the axios request if we're using the local JSON
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_JUNEJSON_CDN_URL).then(
        (response) => {
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        },
        (error) => {
          console.log(error);
        }
      );
    };
    fetchMorganWebinarJSON();

    // Set the data from the local JSON file
    // setWebinarData(May2023);
    // setBannerData(May2023.banner);
    // setHighlightsData(May2023.highlights);
    // setPropertyData(May2023.property);
    // setTimerData(May2023.countdown);
    // setFormData(May2023.signupform);
  }, []);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(
          "https://resources.swmc.com/jsons/ai-branding.json"
        );
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <Header
          links={links}
          angelAiLink={angelAiLink}
          sunwestLink={sunwestLink}
          fetchpriority="high"
        />
        {bannerData && links ? (
          <>
            <Body
              bannerData={bannerData}
              timerData={timerData}
              formData={formData}
              links={links}
              fetchpriority="high"
            />

            {/* <Suspense fallback={<div />}>
      <LogoSection fetchpriority="low" />
      </Suspense> */}
            <Suspense fallback={<div />}>
              {highlightsData ? (
                <Highlights highlightsData={highlightsData} links={links} />
              ) : (
                ""
              )}
            </Suspense>
            <Suspense fallback={<div />}>
              {propertyData ? <Proprty propertyData={propertyData} /> : ""}
            </Suspense>
            <Suspense fallback={<div />}>
              <EventComponent
                angelAiLink={angelAiLink}
                sunwestLink={sunwestLink}
                links={links}
              />
            </Suspense>
            <Suspense fallback={<div />}>
              <Morganlogos
                angelAiLink={angelAiLink}
                sunwestLink={sunwestLink}
                links={links}
              />
            </Suspense>
            <Suspense fallback={<div />}>
              <Whysunwest
                angelAiLink={angelAiLink}
                swmcLink={swmcLink}
                pavanLink={pavanLink}
                sunwestLink={sunwestLink}
                links={links}
                pavanData={pavanData}
              />
            </Suspense>
            <Suspense fallback={<div />}>
              <Footer />
            </Suspense>
            <CookieSetting
              privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
              configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
              analytics={process.env.REACT_APP_ANALYTICS_PATH}
            />
          </>
        ) : (
          ""
        )}
      </CacheBuster>
    </div>
  );
}

export default App;
